import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import useMobileDetect from 'helpers/mobile-detect'

import styles from './about-champs.module.scss'

export default function AboutChamps (props) {
  const [imageUrl, setImageUrl] = useState(
    '/static/images/about/bg-about-champ.png'
  )
  const bgImage = 'url(' + imageUrl + ') no-repeat center center / cover #000000'
  const currentDevice = useMobileDetect()

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width <= 768) {
      setImageUrl('/static/images/about/bg-m-about-champ.png')
    } else {
      setImageUrl('/static/images/about/bg-about-champ.png')
    }
  }, [currentDevice.width])
  return (
    <section className={styles['about-champs']}>
      <div className={styles['about-champs__wrapper']} style={{ background: bgImage }}>
        <div className={styles['about-champs__caption'] + ' col-12 col-md-8'}>
          <h3 className={styles['about-champs__title']}>The man behind the champs</h3>
          <p className={styles['about-champs__text']}>
            Mike has been the man behind the likes of Ronda Rousey, Thiago Alves
            and Carlos Condit, earning a reputation as 'the go-to guy in the
            world of mixed martial arts.' (ELLE)
          </p>
          <p className={styles['about-champs__text-caption']}>
            "Mike Dolce is a guy we respect, we believe in and we know that can
            get results." <br />{' '}
            <span className='author'>- Dana White, UFC President</span>
          </p>
        </div>
        <div className={styles['about-champs__caption-group'] + ' pc'}>
          <img
            className={styles['about-champs__rectangle-red'] + ' img-fluid'}
            src='/static/images/about/bg-rectangle-red.svg'
            alt={'bg'}
          />
          <img
            className={styles['about-champs__rectangle-gray'] + ' img-fluid'}
            src='/static/images/about/bg-rectangle-gray.svg'
            alt={'bg'}
          />
          <Row className={styles['about-champs__list-caption']}>
            <Col xs={12} md={3} className='p-0'>
              <p>"I love the flavor of Mike's meals."</p>
              <span>-Vitor Belfort, UFC world champion</span>
            </Col>
            <Col xs={12} md={5}>
              <p>"Mike Dolce is positive, and he’s a motivator."</p>
              <span>-Duane Ludwig, K1 World Champion</span>
            </Col>
            <Col xs={12} md={4} className='p-0'>
              <p>"This diet totally changed my life."</p>
              <span>-Ronda Rousey, UFC world champion</span>
            </Col>
          </Row>
        </div>

        <div className={styles['about-champs__caption-group-1'] + ' caption-group mobile'}>
          <img
            className={styles['about-champs__rectangle-red'] + ' rectangle-red img-fluid'}
            src='/static/images/about/m-retangle-red.svg'
            alt={'bg'}
          />
          <img
            className={styles['about-champs__rectangle-gray'] + ' rectangle-gray img-fluid'}
            src='/static/images/about/m-retangle-gray.svg'
            alt={'bg'}
          />
          <Row>
            <Col className={'content p-0'}>
              <p>"This diet totally changed my life."</p>
              <span>- Ronda Rousey, UFC world champion</span>
            </Col>
          </Row>
        </div>
        <div className={styles['about-champs__caption-group-2'] + ' caption-group mobile'}>
          <img
            className={styles['about-champs__rectangle-red'] + ' rectangle-red img-fluid'}
            src='/static/images/about/m-retangle-red1.svg'
            alt={'bg'}
          />
          <img
            className={styles['about-champs__rectangle-gray'] + ' rectangle-gray img-fluid'}
            src='/static/images/about/m-retangle-gray1.svg'
            alt={'bg'}
          />
          <Row>
            <Col className={'content p-0'}>
              <p>"The Dolce Diet is the only way I can make weight."</p>
              <span>- Duane Ludwig, K1 World Champion</span>
            </Col>
          </Row>
        </div>
        <div className={styles['about-champs__caption-group-3'] + ' caption-group mobile'}>
          <img
            className={styles['about-champs__rectangle-red'] + ' rectangle-red img-fluid'}
            src='/static/images/about/m-retangle-red1.svg'
            alt={'bg'}
          />
          <img
            className={styles['about-champs__rectangle-gray'] + ' rectangle-gray img-fluid'}
            src='/static/images/about/m-retangle-gray1.svg'
            alt={'bg'}
          />
          <Row>
            <Col className={'content p-0'}>
              <p>"I love the flavor of Mike's meals."</p>
              <span>-Vitor Belfort, UFC world champion</span>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  )
}
